import React, { memo, useCallback, useState } from "react";
import { useFormik } from "formik";

import {
  Button,
  CustomSelect,
  DatePickerComponent,
  DateRangePicker,
  Label,
  SelectBadla,
} from "../";
import { historyFilterTypeOptions } from "../../Static/data";
import { dateFormat } from "../../helper/common";
import {
  API_HISTORY_DAYWISE,
  API_HISTORY_MINUTEWISE,
} from "../../utils/api/ApiConstant";
import { badlaHistorySchema } from "../../Schema/BadlaSchema";
import showToast from "../../utils/toastUtil";

const BadlaHistoryFilter = ({ handlePostRequest }) => {
  const [isClearForm, setIsClearForm] = useState(false);
  const { values, handleSubmit, resetForm, setFieldValue } = useFormik({
    initialValues: {
      type: historyFilterTypeOptions?.[0] || null,
      badla: null,
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
      date: new Date(),
    },
    // validationSchema: badlaHistorySchema,
    onSubmit: ({ badla, date, endDate, startDate, type }) => {
      if (!badla || !date || !endDate || !startDate || !type) {
        showToast.error("All fields are required.");
        return;
      }

      const payload = {
        type: type.value,
        instrumentId: badla,
        startDate: startDate ? dateFormat(startDate).formattedDate : null,
        endDate: endDate ? dateFormat(endDate).formattedDate : null,
        date: date ? dateFormat(date).formattedDate : null,
      };
      const url = type.value ? API_HISTORY_DAYWISE : API_HISTORY_MINUTEWISE;
      handlePostRequest({ url, payload });
    },
  });

  const handleSelectBadla = useCallback(({ badlaValues }) => {
    setFieldValue("badla", badlaValues?.matchScript?._id);
  }, []);

  return (
    <>
      {!values?.type.value && (
        <div className="row m-0 p-0">
          <div className="col-lg-12 recentOrders desktop_ui mt-2">
            <table className="report-card-box">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Buy</th>
                  <th>Sell</th>
                  <th>LTP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>H</td>
                  <td>123</td>
                  <td>123</td>
                  <td>123</td>
                </tr>
                <tr>
                  <td>L</td>
                  <td>456</td>
                  <td>456</td>
                  <td>456</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      <form className="date-input-main" onSubmit={handleSubmit}>
        <div className="row m-0 p-0 align-items-end">
          <div className="col-lg-2 col-12 m-0 p-1">
            <div className="date-input-box">
              <Label htmlFor="" className="lead_text">
                Order Type
              </Label>
              <CustomSelect
                className="dropdown-control "
                options={historyFilterTypeOptions}
                onChange={(selectedOption) => {
                  setFieldValue("type", selectedOption);
                }}
                value={values.type}
                name="type"
                id="type"
                isClearable={false}
              />
            </div>
          </div>

          {values?.type?.value ? (
            <DateRangePicker
              values={values}
              setFieldValue={setFieldValue}
              className="date-input-box"
              customClass="col-lg-2 col-12 m-0 p-1 "
            />
          ) : (
            <div className="col-lg-2 col-12 m-0 p-1 ">
              <div className="date-input-box">
                <Label htmlFor="startDate" className="lead_text">
                  Date
                </Label>
                <DatePickerComponent
                  isClearable={false}
                  selectedDate={values.date}
                  onChange={(date) => setFieldValue("date", date)}
                  placeholderText="Pick a date"
                  // minDate={new Date()}
                />
              </div>
            </div>
          )}

          <SelectBadla
            handleSelectBadla={handleSelectBadla}
            isClearForm={isClearForm}
            setIsClearForm={setIsClearForm}
          />

          <div className="col-lg-1 col-6 m-0 p-1">
            <Button
              type="submit"
              className="ban-man-box history-btn"
              title="View"
            >
              View
            </Button>
          </div>
          <div className="col-lg-1 col-6 m-0 p-1">
            <Button
              type="button"
              className="ban-man-box clear-btn"
              title="Clear"
              onClick={() => {
                setIsClearForm((prev) => !prev);
                resetForm();
              }}
            >
              Clear
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default memo(BadlaHistoryFilter);
